export default "__VITE_ASSET__lg8HZVNs__"